import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import Header from '../components/header';
import Footer from '../components/footer';
import SEOTags from '../common/SEO';
import PersonalInjuryBanner from './../assets/img/banner/personal-injury.jpg';

import { Link, useLocation } from 'react-router-dom';

const PersonalInjury = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const loadVideo = () => {
        setVideoLoaded(true);
    };
    useEffect(() => {
        SEOTags(
            "Personal Injury | Figgers Law",
        );
    }, [])
    return (
        <>

            <Header></Header>
            <section style={{
                backgroundImage: isMobile
                    ? `linear-gradient(rgba(0,0,0,.6), rgba(0,0,0,.6)), url(${PersonalInjuryBanner})`
                    : `url(${PersonalInjuryBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "right",
            }}
                className="sub-hero pa-hero">
                <div className="container">
                    <div className="section-label">Practice Area</div>

                    <h1>Business Law & <br></br>Commercial Litigation</h1>

                    <p>
                        When it’s your business, it’s personal.
                    </p>

                    <div
                        style={{
                            marginTop: "20px",
                            display: "flex",
                            gap: "12px",
                            flexWrap: "wrap",
                        }}
                    >
                        <Link to={'/contact-us'} className="btn-gold">
                            Free Consultation
                        </Link>

                        <a href="tel:+8556435291" className="btn-outline-ivory">
                            Call (855) 643-5291
                        </a>
                    </div>
                </div>
            </section>

            {/* Body */}
            <section className="sub-body alt">
                <div className="container">
                    <div className="pa-grid">
                        <div className="sub-content">
                            <div className="businesslaw_head"><h3>“At Figgers Law, we treat our clients like family.”</h3></div>
                            <p>&nbsp;</p>
                            <p>
                                <b>You worked hard to build your business. </b>So when a contract falls apart, a partner relationship turns hostile, money is on the line, or a deal suddenly becomes a dispute, it does not feel like “just business.” It affects what you built, what you invested, and what comes next.
                                Figgers Law helps business owners, entrepreneurs, companies, and organizational leaders protect their interests before problems escalate and provides strategic representation when litigation becomes necessary.
                                We believe business clients deserve more than legal jargon and a stack of documents. You should understand your options, the risks, the leverage you have, and the practical effect each decision may have on your business. Our job is to help you see the full picture and move forward with a strategy that makes sense.

                            </p>


                            <h2>Contracts: Know What You Are Agreeing To</h2>

                            <p>
                                A contract should protect the deal when things go right and protect the business when they do not. Before you sign, we help identify obligations, risk, payment terms, exit provisions, remedies, and language that may become important later.
                            </p>

                            <p>
                                When a dispute has already started, we do not look at one paragraph in isolation. We evaluate the agreement alongside the parties’ communications, payments, amendments, course of performance, and the business reality surrounding the deal.
                            </p>

                            <h2>Ownership, Member & Shareholder Disputes</h2>

                            <p>Few business disputes become personal faster than a disagreement between owners. Questions about control, money, access to information, management decisions, distributions, or a possible exit can put the entire company at risk.</p>
                            <p>Figgers Law represents clients in matters involving:</p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    LLC member, shareholder, and partnership disputes
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Voting, control, and management conflicts
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Disputes over distributions, compensation, or company funds
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Access to books, records, and financial information
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Alleged misuse of company assets or authority
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Fiduciary-duty claims
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Owner removal, withdrawal, or separation
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Buyout negotiations and disputed ownership rights
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Business dissolution and breakup disputes
                                </li>
                            </ul>

                            <h2>Corporate Governance &amp; Business Decision-Making</h2>

                            <p>
                                Good governance is not paperwork for paperwork’s sake. Clear authority,
                                proper approvals, and well-drafted governing documents can prevent expensive
                                disputes and strengthen the business when disagreements arise.
                            </p>

                            <p>
                                We assist with governance structures, operating and shareholder documents,
                                ownership and voting rights, internal approvals, management authority,
                                business risk allocation, and strategic legal review before significant
                                business decisions.
                            </p>

                            <p>
                                <strong>
                                    Your lawyer should understand the business behind the legal issue,
                                    not just the lawsuit in front of it.
                                </strong>
                            </p>

                            <h2>When a Business Relationship Breaks Down</h2>

                            <p>
                                A broken business relationship can affect far more than a single contract.
                                It can affect cash flow, customers, operations, ownership, property,
                                reputation, and future opportunities. That is why the first question is
                                not always, “Can we sue?” The better question is, “What outcome actually
                                protects the business?”
                            </p>

                            <p>
                                Sometimes that means resolving the matter quietly and efficiently.
                                Sometimes it means drawing a firm line. And sometimes litigation is
                                necessary. We help clients evaluate those options early so the legal
                                strategy serves the business objective.
                            </p>

                            <h2>Commercial Litigation</h2>

                            <p>
                                When a dispute cannot be resolved informally, Figgers Law provides
                                strategic representation from pre-suit analysis through litigation and
                                resolution. Commercial disputes may involve:
                            </p>

                            <ul class="about-list">
                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Breach of contract
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Business-to-business disputes
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Fraud and misrepresentation
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Business torts
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Interference with contractual or business relationships
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Ownership and governance disputes
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Payment and collection disputes
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Commercial lease disputes
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Vendor, supplier, and service-provider disputes
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Declaratory or injunctive relief
                                </li>

                                <li>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <path d="m9 12 2 2 4-4"></path>
                                    </svg>
                                    Pre-suit demands, settlement negotiations, and negotiated resolutions
                                </li>
                            </ul>

                            <h2>Business Breakups, Buyouts &amp; Ownership Separations</h2>

                            <p>
                                Not every business relationship is meant to continue. When owners can no
                                longer move forward together, we help clients assess their rights,
                                financial exposure, leverage, and available paths toward separation.
                            </p>

                            <p>
                                That may include a negotiated buyout, transfer of ownership, allocation
                                of assets and liabilities, management transition, resolution of
                                record-access issues, or litigation when an orderly exit cannot be
                                achieved.
                            </p>

                            <h2>Before the Lawsuit: Strategy Matters</h2>

                            <p>
                                Some of the most valuable legal work happens before anyone files a
                                complaint. Early involvement can help preserve evidence, clarify
                                contractual rights, prevent damaging communications, evaluate exposure,
                                and create leverage for a negotiated resolution.
                            </p>

                            <p>
                                Figgers Law assists with contract and document analysis, legal risk
                                assessments, demand letters and responses, evidence preservation,
                                negotiation strategy, litigation-readiness assessments, and pre-suit
                                positioning.
                            </p>

                            <h2>Business-Minded Legal Counsel</h2>

                            <p>
                                We understand that the technically available legal option is not always
                                the best business decision. Litigation has costs, distractions, timing
                                considerations, and operational consequences. Our approach considers the
                                law and the commercial reality together.
                            </p>

                            <p>
                                At Figgers Law, you will know what we are trying to accomplish, why a
                                strategy is being recommended, and what the potential risks are. We want
                                our clients to feel informed, protected, and confident in the decisions
                                they make.
                            </p>

                            <div className='businesslaw_head'>


                                <h2>LET’S TALK ABOUT YOUR BUSINESS</h2>

                                <p>
                                    If a contract, deal, ownership issue, or business dispute is keeping you
                                    up at night, contact Figgers Law to discuss the situation and the options
                                    available to you.
                                </p>

                                <p>
                                    <strong style={{ color: '#D5B269' }}>At Figgers Law, we treat our clients like family.</strong>
                                </p>

                            </div>

                            <p style={{ fontSize: '14px', margin: '11px 0' }}>
                                <strong>Website disclaimer:</strong> The information on this page is for
                                general informational purposes only and is not legal advice. Viewing this
                                website or contacting Figgers Law does not create an attorney-client
                                relationship. Representation begins only after conflicts are cleared and
                                a written engagement agreement is signed. Past results do not guarantee
                                future outcomes.
                            </p>
                        </div>

                        {/* Sidebar */}
                        <aside className="pa-sidebar">
                            <div className="pa-sidebar-card">
                                <h3>How Figgers Law Helps Businesses</h3>
                                <p style={{ fontSize: '14px', margin: '10px 0' }}>We provide counsel and representation in matters involving:</p>

                                <ul className="pa-helps">
                                    <li> Business contracts and commercial agreements</li>
                                    <li> Contract drafting, review, negotiation, interpretation, and enforcement</li>
                                    <li>  Operating agreements, shareholder agreements, and partnership agreements</li>
                                    <li> LLC, corporate, and ownership disputes</li>
                                    <li>  Board, member, shareholder, and management authority</li>
                                    <li> Vendor, consultant, service, and supplier agreements</li>
                                    <li> Commercial leases and lease disputes</li>
                                    <li> Business transactions and negotiated commercial arrangements</li>
                                    <li> Buyouts, ownership transitions, and business separations</li>
                                    <li> Pre-suit demands, negotiations, and dispute strategy</li>
                                </ul>
                            </div>

                            <div className="pa-sidebar-cta">
                                <h4>Free Case Evaluation</h4>

                                <p>
                                    Speak directly with Natlie G. Figgers about your case — no
                                    cost, no obligation.
                                </p>

                                <Link to={'/contact-us'}
                                    className="btn-gold"
                                    style={{
                                        width: "100%",
                                        justifyContent: "center",
                                        marginTop: "12px",
                                    }}
                                >
                                    Request Free Review
                                </Link>
                            </div>

                            <div className="pa-sidebar-card">
                                <h4>No Upfront Fees</h4>

                                <p>
                                    Figgers Law works on a contingency fee basis. You pay nothing
                                    unless we recover compensation for you.
                                </p>
                            </div>
                        </aside>
                    </div>

                    {/* Related Practice Areas */}
                    <div className="pa-related">
                        <div className="section-label">Related Practice Areas</div>

                        <h2
                            className="font-display"
                            style={{ margin: "8px 0 20px" }}
                        >
                            Also Handled by Figgers Law
                        </h2>

                        <div className="pa-related-grid">
                            <Link
                                to="/rear-end-collision"
                                className="related-card"
                            >
                                <h4>Rear-End Collision</h4>

                                <p>
                                    Protecting victims of sudden-impact crashes and related
                                    injuries.
                                </p>
                            </Link>

                            <Link
                                to="/car-accidents"
                                className="related-card"
                            >
                                <h4>Car Accidents</h4>

                                <p>
                                    Representation for accident victims dealing with injuries,
                                    insurance, and recovery.
                                </p>
                            </Link>

                            <Link
                                to="/pedestrian-accident"
                                className="related-card"
                            >
                                <h4>Pedestrian Accident</h4>

                                <p>
                                    Advocating for pedestrians injured due to negligent drivers.
                                </p>
                            </Link>

                            <Link
                                to="/bicycle-accidents"
                                className="related-card"
                            >
                                <h4>Bicycle Accidents</h4>

                                <p>
                                    Legal support for cyclists facing injury, liability, and
                                    compensation challenges.
                                </p>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
            <Footer></Footer>
        </>

    );
};

export default PersonalInjury;
